import { render, staticRenderFns } from "./smartWarning.vue?vue&type=template&id=650d116b&scoped=true"
import script from "./smartWarning.vue?vue&type=script&lang=js"
export * from "./smartWarning.vue?vue&type=script&lang=js"
import style0 from "./smartWarning.vue?vue&type=style&index=0&id=650d116b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650d116b",
  null
  
)

export default component.exports